import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Layout } from 'features/auth';
import { EmailOTPForm } from '../components/EmailOTPForm';
import GoogleAuthForm from '../components/GoogleAuthForm';
import Cookies from 'js-cookie';
import { generateDeepLink, parseDeepLink } from 'react-deep-link';
import { REMOTE_URLS } from 'config/remotes';
import SMSAuthForm from '../components/SMSAuthForm';

export const TwoFA = () => {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState(Cookies.get('loginData'));

  const [step, setStep] = useState('google_auth');

  useEffect(() => {
    const fetchAuthState = () => {
      if (!loginData) {
        navigate('/auth/login');
        return;
      }

      const parsedData = JSON.parse(loginData);

      const parsedDeepLinkData = parseDeepLink(
        new URLSearchParams(window.location.search)
      );

      Cookies.set('authorizeDomainKey', parsedData.app);

      const baseUrl = REMOTE_URLS[parsedData.app];

      if (parsedData?.allow2FA != 1) {
        const url = generateDeepLink({
          baseUrl: baseUrl,
          route: parsedData.redirectPath,
          state: {
            token: parsedData.temp_token,
            app: parsedData.app,
            ...parsedDeepLinkData,
          },
        });

        Cookies.remove('token');
        Cookies.remove('temp_token');
        Cookies.remove('loginData');
        window.location.href = url;
      }
    };

    fetchAuthState();
  }, []);

  let smsLabel;
  if (step === 'sms_otp') {
    smsLabel = 'SMS OTP Required';
  } else if (step === 'email_otp') {
    smsLabel = 'Email OTP Required';
  } else {
    smsLabel = 'Authenticator Code Required';
  }

  return (
    <Layout title={smsLabel}>
      {step === 'google_auth' && (
        <GoogleAuthForm
          onSuccess={() => {
            console.log('Google Auth Success');
            setStep('sms_otp');
          }}
        />
      )}

      {step === 'sms_otp' && (
        <SMSAuthForm
          onSuccess={() => {
            console.log('SMS Auth Success');
            setStep('email_otp');
          }}
        />
      )}

      {step === 'email_otp' && <EmailOTPForm />}

      {step === 'loading' && (
        <div className="text-center text-sm text-gray-500">
          Loading authentication details...
        </div>
      )}
    </Layout>
  );
};
